import React from 'react'

import SignUpForm from './Form'
import UIAppSignInUpPage from '../UI/App/SignInUpPage'

const SignUpPage = () => <UIAppSignInUpPage form={<SignUpForm />} />

export default SignUpPage
